var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mavon-editor',{class:_vm.withMaxHeight?'md':undefined,attrs:{"value":_vm.value},on:{"change":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }